<template>
	<div>
		<el-form :model="form" ref="form" labelPosition="right" autoComplete="on" labelWidth="120px">
			<el-form-item prop="subbrandId" label="品牌：" :rules="[{required: true, trigger: 'blur', message: '请选择品牌'}]">
				<el-select v-model="form.subbrandId" placeholder="请选择品牌" style="width:450px;" clearable>
					<el-option v-for="item in config_data['brands']" :key="item.code" :label="item.name" :value="item.code"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="mobileNum2" label="手机号码：" :rules="[{required: true, trigger: 'blur', message: '请输入手机号码'}]">
				<el-input disabled v-model="form.mobileNum2" placeholder="请输入手机号码" style="width:450px;" maxlength="11" clearable></el-input>
			</el-form-item>
			<el-form-item prop="configId" label="短信账号：" :rules="[{required: true, trigger: 'blur', message: '请选择短信账号'}]">
				<el-select v-model="form.configId" placeholder="请选择短信账号" style="width:450px;" clearable>
					<el-option v-for="item in sms_account" :key="item.configId" :label="item.configName" :value="item.configId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="templetId" label="短信模板：">
				<el-select v-model="form.templetId" :disabled="!form.subbrandId" placeholder="请选择短信模板" style="width:450px;" clearable>
					<el-option v-for="item in sms_template" :key="item.templetId" :label="item.name" :value="item.templetId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="smsBody" label="短信内容：" :rules="[{required: true, trigger: 'blur', message: '请输入短信内容'}]">
				<el-input v-model="form.smsBody" ref="singleText" :rows="4" type="textarea" placeholder="请输入短信内容" style="width:450px;" clearable></el-input>
			</el-form-item>
			<el-form-item prop="scheduleTime" label="预约发送时间：">
				<el-date-picker
					:picker-options="setDisabledDate"
					v-model="form.scheduleTime"
					type="datetime"
					:clearable="false"
					value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="请选择预约发送时间"  style="width:450px;">
				</el-date-picker>
			</el-form-item>
			<el-divider></el-divider>
			<el-form-item style="float: right;padding-right: 30px;">
				<el-button @click.stop="handleSave" :loading="loading" size="mini" type="primary">发 送</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: ['customerForm', 'sendPhone'],
	computed: {
		setDisabledDate() {
			return {
				disabledDate(time){
					let now = new Date();
					now.setDate(now.getDate() - 1);
					now.setHours(now.getHours());
					now.setMinutes(now.getMinutes());
					now.setSeconds(now.getSeconds());
					return time < now;
				}
			}
		},
		...mapGetters([
			'isShowPhone'
        ])
	},
	data() {
		return {
			dialogVisibleCustomer: false,
			loading: false,
			form: {
				customerId: '',
				mobileNum: '',
				mobileNum2: '',
				subbrandId: '',
				configId: '',
				templetId: '',
				smsBody: '',
				remark: '',
				scheduleTime: '',
			},
			config_data: {
				brands: [],
				suppliers: []
			},
			sms_account: [],
			sms_template: [],
			flag: 0
		}
	},
	watch: {
		'form.subbrandId': {
			handler(val) {
				if(val) {
					this.getTemplateData();
				}
			}
		},
		'form.templetId': {
			handler(val) {
				if(val) {
					if(this.flag == 0) {
						return;
					}
					this.$api.apiPostSmsGetTemplateBody({templetId: val}).then(response => {
						if(response.errcode != 0) return;
						this.form.smsBody = response.data.templetBody;
					});
				}
			}
		}
	},
	async created() {
		await this.getConfigData();
		await this.getAccountData();
		this.form.customerId = this.customerForm.customerId;
		this.form.subbrandId = this.customerForm.subBrand;
		this.form.mobileNum = this.sendPhone;
		this.form.mobileNum2 = this.isShowPhone ? this.sendPhone : this.hiddenPhone(this.sendPhone);
		setTimeout(() => {
			this.flag = 1;
		}, 500);
	},
	methods: {
		handleSave() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.$api.apiPostSmsSaveSmsSingle(this.form).then(response => {
						if(response.errcode != 0) return;
                        this.$notify({
                            title: "提交成功",
                            offset: 70,
                            type: "success"
                        });
						this.loading = false;
						this.$emit('closeDialogFormVisible', true);
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
		resetForm() {
			this.form = {
				customerId: '',
				mobileNum: '',
				mobileNum2: '',
				subbrandId: '',
				configId: '',
				templetId: '',
				smsBody: '',
				remark: '',
				scheduleTime: '',
			}
			if (this.$refs["form"]) {
				this.$refs["form"].clearValidate();
			}
		},
		getConfigData() {
			this.$api.apiPostSmsConfigData().then(response => {
				if(response.errcode != 0) return;
				this.config_data = Object.assign(this.config_data, response.data);
			});
		},
		getAccountData() {
			this.$api.apiPostSmsConfigList().then(response => {
				if(response.errcode != 0) return;
				this.sms_account = response.data['configList'];
			});
		},
		getTemplateData() {
			this.$api.apiPostSmsCascadeTemplateList({
				subbrandId: this.form.subbrandId
			}).then(response => {
				if(response.errcode != 0) return;
				this.sms_template = response.data['templetList'];
				
			});
		}
	}
}
</script>
